import React from "react";
import { Card } from "./styles";

import ReportsUnimedView from "../../views/ReportsUnimed/index.jsx";

export default function HomeUnimed() {
  return (
    <div>
      <Card>
        <ReportsUnimedView />
      </Card>
    </div>
  );
}
